module.exports = __webpack_public_path__ + "static/img/network-04.6329231.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/register/network/network-04.jpg
// module id = vYQd
// module chunks = 1